enableHiddenText();
function enableHiddenText() {
  var buttons = document.getElementsByClassName("btn-read-more");
  for (var i = 0; i < buttons.length; i++) {
    const button = buttons[i];
    button.addEventListener("click", function () {
      onButtonClick(button);
    });
  }
}

function onButtonClick(button) {
  var texts = document.getElementsByClassName("new-hidden-text-text-container");

  for (var i = 0; i < texts.length; i++) {
    var element = texts[i];
    var icon = button.querySelector("img");

    // detect collapse (was open -> now closing)
    var isClosing = element.classList.contains("active");
    var isMobile = window.matchMedia("(max-width: 767px)").matches;

    // ONLY for mobile + closing: record button position before collapse
    var beforeTop = null;
    if (isMobile && isClosing) {
      beforeTop = button.getBoundingClientRect().top;
    }

    if (isClosing) {
      // Hide
      element.classList.remove("active");
      button.classList.remove("active");
      icon.src =
        "https://cdn.shopify.com/s/files/1/0603/9594/6243/files/ic-plus-circle.png?v=1751644003";

      // ONLY for mobile + closing: compensate scroll so viewport doesn't jump
      if (isMobile) {
        requestAnimationFrame(function () {
          var afterTop = button.getBoundingClientRect().top;
          var delta = afterTop - beforeTop;

          if (Math.abs(delta) > 1) {
            window.scrollBy({ top: delta, left: 0, behavior: "auto" });
          } else {
            // fallback: ensure button is visible
            button.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        });
      }
    } else {
      // Show (unchanged)
      element.classList.add("active");
      button.classList.add("active");
      icon.src =
        "https://cdn.shopify.com/s/files/1/0603/9594/6243/files/ic-minus-circle.png?v=1751644127";
    }
  }
}

// Select all read more icons
const buttons = document.querySelectorAll('.btn-read-more');
let pulseIndex = 0;

function pulse(icon) {
  // Only pulse if the button is not active
  const button = icon.closest('.btn-read-more');
  if (button.classList.contains('active')) {
    // Skip pulsing when active
    setTimeout(() => {
      // Move to next icon
      pulseIndex = (pulseIndex + 1) % buttons.length;
      const nextIcon = buttons[pulseIndex].querySelector('img');
      pulse(nextIcon);
    }, 500);
    return;
  }

  icon.style.transition = 'transform 0.6s ease-in-out';
  icon.style.transform = 'scale(1.2)';

  setTimeout(() => {
    icon.style.transform = 'scale(1)';

    setTimeout(() => {
      // Move to next icon
      pulseIndex = (pulseIndex + 1) % buttons.length;
      const nextIcon = buttons[pulseIndex].querySelector('img');
      pulse(nextIcon);
    }, 400); // Delay before next pulse starts
  }, 600); // Time at scale(1.2)
}

// Start pulsing the first icon
if (buttons.length > 0) {
  const firstIcon = buttons[0].querySelector('img');
  pulse(firstIcon);
}

